import swal from 'sweetalert';

// 401 / 419 mean the session expired (e.g. a tab restored from the browser cache)
const SESSION_EXPIRED_STATUSES = [401, 419];
let redirectingToLogin = false;

async function displayApiError({ props }) {
    const { error } = props;

    if (error.response && SESSION_EXPIRED_STATUSES.includes(error.response.status)) {
        // reload so the server redirects to the login page and remembers the intended url
        if (!redirectingToLogin) {
            redirectingToLogin = true;
            window.location.reload();
        }
        return;
    }

    const message = [error.message];

    if (error.response && error.response.data && error.response.data.message) {
        message.push(error.response.data.message);
    }
    if (error.request && error.request.responseURL) {
        message.push('&nbsp;');
        message.push(error.request.responseURL);
    }

    await swal({
        title: 'Er liep iets mis..',
        content: {
            element: 'div',
            attributes: {
                innerHTML: `Contacteer de IT-afdeling van die Keure en vermeld volgende boodschap:<br/> <div class="swal-error-details">${message.join(
                    '<br />'
                )}</div>`,
            },
        },
        icon: 'error',
    });
}

export default displayApiError;
